import { slugifyStorage } from '../../../../../../../lib/transliterate'
import { Option } from '../../../../../../../lib/options'
import { containsInterpolatedStorage } from '../../../../../../../features/storages'

import { CollapsibleFormContext } from '../../../../../../CollapsibleForm/types'

export function onChange(
  option: Option | null,
  uiSchemaOnChange: (value: string | undefined) => void
): void {
  const { value } = option ?? {}

  if (!value) {
    uiSchemaOnChange(value)
    return
  }

  if (containsInterpolatedStorage(value)) {
    return
  }

  uiSchemaOnChange(slugifyStorage(value))
}

export function getCalcValueSubtraction(formContext: CollapsibleFormContext): string {
  const action = formContext.initialFormData?.action

  if (action === 'clearUserData') {
    return '6px'
  }

  return '26px'
}
